import { Component, HostListener, OnInit } from '@angular/core';
import { Material, OutwardMaterial } from '../../../shared/classes/Material';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OutwardService } from '../../../shared/services/outward.service';
import { DataContextService } from '../../../shared/services/data-context.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Outward } from '../../../shared/classes/Outward';
import * as moment from 'moment';
import { ModalSize } from 'src/app/Enum/usersFilterEnums';
import { ApproverCommentsComponent } from '../../outward-approver/approver-comments/approver-comments.component';
import { DeclinePopupComponent } from '../../inward-requests/view-inward/decline-popup/decline-popup.component';
import { CancelPopupComponent } from './cancel-popup/cancel-popup.component';
import * as mammoth from 'mammoth';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-view-outward',
  templateUrl: './view-outward.component.html',
  styleUrls: ['./view-outward.component.less']
})
export class ViewOutwardComponent implements OnInit {
  dateInputData: any = {};
  requestId: string;
  requestName: string;
  requestTypeId: number;
  requestTypeName: string;
  requestDateTime:any;
  returnDateTime: any;
  remark: string;
  gatepassNumber: string;
  GatepassNo:string;
  serialNumber: string;
  revisedDateTime: any;
  materialSentToVendorId: number;
  materialSentToVendorName: string;
  materialCarriedByVendorId: number;
  materialCarriedByVendorName: string;
  approverEmailL1: string;
  approverEmailL2: string;
  practiceId: number;
  practiceName: string;
  purpose: string;
  status: string;
  statusId: number;
  previousStatusId:number;
  isActive: boolean;
  cityId: number;
  cityName: string;
  officeId: number;
  officeName: string;
  authorizedBy:string;
  createdBy:string;
  declinedByNotes:string;
  cancelledByNotes:string;
  updatedBy:string;
 // materialList:Material[] = [];
 fTime: Date = new Date;
  dTime:Date=new Date;
  fromtimevalue: any;
  duetimevalue:any;
  rdTime:Date=new Date;
  revisedduetimevalue:any;
  public materialList:OutwardMaterial[] = [];
  OutwardDetails:Outward;
  id: any;
  searchText : string = "";
   service_URL: any;
  private unsubscribe$ =new Subject<void>();
  EditOutwardDetails:any;
  modalRef: BsModalRef;
  DueDteCompare:boolean;
  showLoading: boolean = true;
  Appr1Data: any;
  Appr2Data: any;
  getAllUsers:any;
  receivedDateTime: any;
  receiveddTime:Date=new Date;
  receivedduetimevalue:any;
  attachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  isMobileView = false;
  private readonly mobileBreakpoint = 768;
  constructor(private location: Location,
    private route: ActivatedRoute,
    private outwardService: OutwardService,
    private _dataContextService: DataContextService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private rounter:Router
    ) {
    this.service_URL = ConstantsService;
  }


  ngOnInit(): void {
    this.syncViewportState();
    this.getAppr1Data();
    this.id = this.route.snapshot.params['id'];
    this.fillOutwardData(this.id);
     //this.dateInputData.EndDate = new Date();
    
    //  console.log(this.id);

     this.dateInputData.StartDate = new Date();
     //this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate() - 7);
     this.dateInputData.maxDate = new Date();
     this.dateInputData.FromMinDate = new Date();
     this.dateInputData.FromMinDate.setDate(this.dateInputData.StartDate.getDate() - 1095);
      
         
  }
    addMaterial(){
      this.materialList.push(new OutwardMaterial())
      // console.log(this.materialList)
    }
  
    removeMaterial(index:number){
      if(index > -1){
       this.materialList.splice(index,1);
      }
    }
    goBack() : void{
      this.location.back();
    }
  
    getAppr1Data()
    {
      this._dataContextService.get<any>(this.service_URL.Users.getUser)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.Appr1Data=res.filter(x=>x.isL1==true);
        this.Appr2Data=res.filter(x=>x.isL2==true);
        this.getAllUsers=res;
        this.fillOutwardData(this.id);
      })
      
    }

fillOutwardData(id: any) {
  let url =this.service_URL.OutwardDetails.GetDataById+'/'+id;
       
  this._dataContextService.get<any>(url)
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe(res=>{
    this.getAppr1Data();
    this.EditOutwardDetails=res;    
    this.OutwardDetails=this.EditOutwardDetails;
    this.requestId=this.OutwardDetails.serialNumber;
    this.requestName=this.OutwardDetails.requestName;
    this.requestTypeName=this.OutwardDetails.requestTypeName;
    this.requestDateTime= moment(this.OutwardDetails.requestDateTime).format("MMM/DD/yy");
    this.returnDateTime=moment(this.OutwardDetails.returnDateTime).format("MMM/DD/Y");
    this.revisedDateTime=moment(this.OutwardDetails.revisedDate).format("MMM/DD/Y");
    this.receivedDateTime=moment(this.OutwardDetails.receivedDate).format("MMM/DD/Y");
    this.receiveddTime=new Date(this.OutwardDetails.receivedDate);
    this.receivedduetimevalue=this.GetTimeForDates(this.receiveddTime);
    this.fTime =new Date(this.OutwardDetails.requestDateTime);
    this.fromtimevalue = this.GetTimeForDates(this.fTime);
    this.dTime=new Date(this.OutwardDetails.returnDateTime);
    this.duetimevalue=this.GetTimeForDates(this.dTime);
    this.rdTime=new Date(this.OutwardDetails.revisedDate);
    this.revisedduetimevalue=this.GetTimeForDates(this.rdTime);
    this.materialSentToVendorName=this.OutwardDetails.materialSentToVendorName;
    this.materialCarriedByVendorName=this.OutwardDetails.materialCarriedByVendorName;
   if(this.Appr1Data!=undefined && this.Appr1Data!=null ){
    //console.log(this.Appr1Data.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1));
    const l1User = this.Appr1Data.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1);
    if(l1User.length > 0){
      this.approverEmailL1 = l1User[0].firstLastName;
    } else {
       //console.log(this.getAllUsers.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1));
      const l1AllUser = this.getAllUsers.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1);
      this.approverEmailL1 = l1AllUser.length > 0 ? l1AllUser[0].firstLastName : this.OutwardDetails.approverEmailL1;
    }
    
    }//this.OutwardDetails.approverEmailL1;
    if(this.Appr2Data!=undefined && this.Appr2Data!=null ){
    const l2User = this.Appr2Data.filter(x=>x.emailId==this.OutwardDetails.approverEmailL2);
    if(l2User.length > 0){
      this.approverEmailL2 = l2User[0].firstLastName;
    } else {
      const l2AllUser = this.getAllUsers.filter(x=>x.emailId==this.OutwardDetails.approverEmailL2);
      this.approverEmailL2 = l2AllUser.length > 0 ? l2AllUser[0].firstLastName : this.OutwardDetails.approverEmailL2;
    }
  }
    //this.OutwardDetails.approverEmailL2;
    this.authorizedBy=this.OutwardDetails.authorizedBy;
    this.practiceName=this.OutwardDetails.practiceName;
    this.purpose=this.OutwardDetails.purpose;
    this.gatepassNumber=this.OutwardDetails.gatepassNo;
    this.cityName=this.OutwardDetails.cityName;
    this.officeName=this.OutwardDetails.officeName;
    this.remark=this.OutwardDetails.remark;
    this.materialList=this.OutwardDetails.materialList;
    this.declinedByNotes=this.OutwardDetails.declinedByNotes;
    this.cancelledByNotes=this.OutwardDetails.cancelledByNotes;
    this.status=this.OutwardDetails.status;
    this.previousStatusId=this.OutwardDetails.previousStatusId;
    if (this.OutwardDetails.attachedFiles && this.OutwardDetails.attachedFiles.length > 0) {
      this.attachedFiles = this.OutwardDetails.attachedFiles;
    } else {
      this.attachedFiles = [];
    }

    this.showLoading = false;

  })

        
}
GetTimeForDates(date: Date): string {
  let time = moment(date).format("hh:mm A");
  return time;
}
@HostListener('window:resize')
onWindowResize(): void {
  this.syncViewportState();
}
DeclineRequest(selectedRequest : any){
  this.modalRef = this.modalService.show(CancelPopupComponent,{
    initialState : {
      selectedRequest : selectedRequest
    }
  })
  this.modalRef.setClass(ModalSize.Large);
 
}
back(){
  this.rounter.navigate(['/Outward']); 
}
viewFile(index: number) {
  if (this.attachedFiles.length > 0 && index < this.attachedFiles.length) {
    const file = this.attachedFiles[index];
    const fileName: string = file.name;
    const fileId = file.fileId;
    const extension = fileName.split('.').pop()?.toLowerCase();

    console.log(`Viewing file: ${fileName}, reqId: ${this.requestId}, fileId: ${fileId}`);
    this._dataContextService.get<any>(`${this.service_URL.OutwardDetails.Download}?reqId=${this.id}&fileId=${fileId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        console.log("download file result: " + res);
        const base64 = res.file.fileBase64;
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob: Blob;
        let mimeType: string;
        
        switch (extension) {
          case 'pdf':
            mimeType = 'application/pdf';
            break;
          case 'doc':
          case 'docx':
            mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            break;
          case 'xls':
          case 'xlsx':
            mimeType = 'application/vnd.ms-excel';
            break;
          case 'jpg':
          case 'jpeg':
            mimeType = 'image/jpeg';
            break;
          case 'png':
            mimeType = 'image/png';
            break;
          default:
            mimeType = 'application/octet-stream';
        }

        blob = new Blob([byteArray], { type: mimeType });
        const blobURL = URL.createObjectURL(blob);
        const fileWindow = window.open("");
        if (fileWindow) {
          if (mimeType.startsWith('image/')) {
            fileWindow.document.write(`<img src='${blobURL}' width='100%' height='100%' />`);
          } else if (mimeType === 'application/pdf') {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          } else if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            mammoth.convertToHtml({ arrayBuffer: byteArray.buffer })
              .then((result) => {
                fileWindow.document.write(result.value);
              })
              .catch((error) => {
                console.log(error);
                this.toast.error("File could not be rendered");
              });
          } else if (mimeType === 'application/vnd.ms-excel') {
            const workbook = XLSX.read(byteArray, { type: 'array' });
            const html = XLSX.utils.sheet_to_html(workbook.Sheets[workbook.SheetNames[0]]);
            fileWindow.document.write(html);
          } else {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          }
        }
      },
      (error) => {
        console.log(error);
        this.toast.error("File could not be downloaded");
      });
  } else {
    console.log("Invalid file index or no attached files.");
  }
}

private syncViewportState(): void {
  if (typeof window === 'undefined') {
    this.isMobileView = false;
    return;
  }
  this.isMobileView = window.innerWidth <= this.mobileBreakpoint;
}
}
